// import HyperLinkColumn from "@/components/functionals/HyperLinkColumn.vue";
import HyperlinkForBugedtExecution from "@/components/functionals/HyperlinkForBugedtExecution.vue";

const Months = (thiss) => [
  {
    prop: "cuenta",
    name: "Cuenta",
    label: "Cuenta",
    minWidth: 120,
    fixed: true,
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "nombre",
    name: "Nombre Cuenta",
    label: "Nombre Cuenta",
    minWidth: 250,
    fixed: true,
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "ene",
    name: "Enero",
    label: "Enero",
    minWidth: 150,
    cellAtrrs: {
      mes: 1,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "feb",
    name: "Febrero",
    label: "Febrero",
    minWidth: 150,
    cellAtrrs: {
      mes: 2,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "mar",
    name: "Marzo",
    label: "Marzo",
    minWidth: 150,
    cellAtrrs: {
      mes: 3,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "abr",
    name: "Abril",
    label: "Abril",
    minWidth: 150,
    cellAtrrs: {
      mes: 4,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "may",
    name: "Mayo",
    label: "Mayo",
    minWidth: 150,
    cellAtrrs: {
      mes: 5,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "jun",
    name: "Junio",
    label: "Junio",
    minWidth: 150,
    cellAtrrs: {
      mes: 6,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "jul",
    name: "Julio",
    label: "Julio",
    minWidth: 150,
    cellAtrrs: {
      mes: 7,
      editEneable: false, // thiss.editEneable,
      mes2: "July",
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "ago",
    name: "Agosto",
    label: "Agosto",
    minWidth: 150,
    cellAtrrs: {
      mes: 8,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "sep",
    name: "Septiembre",
    label: "Septiembre",
    cellAtrrs: {
      mes: 9,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    minWidth: 150,
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "oct",
    name: "Octubre",
    label: "Octubre",
    cellAtrrs: {
      mes: 10,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    minWidth: 150,
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "nov",
    name: "Noviembre",
    label: "Noviembre",
    cellAtrrs: {
      mes: 11,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    minWidth: 150,
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "dic",
    name: "Diciembre",
    label: "Diciembre",
    cellAtrrs: {
      mes: 12,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    minWidth: 150,
    formatter: HyperlinkForBugedtExecution
  },
  {
    prop: "tot",
    name: "Total",
    label: "Total",
    minWidth: 150,
    fixed: "right",
    formatter: HyperlinkForBugedtExecution
  }
];

const Actions = [
  /*
  { 
    icon: "el-icon-edit",
    label: "Editar Montos",
    command: "edit-amount-acc",
    condition: (row) => row.negrita !== 'S' && row.negrita !== 'T'  
  }
  */
];

export { Months, Actions };
